import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
// import './App.css';
import App from './App';
import { unregister } from './registerServiceWorker';
// import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
unregister();
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js